export function populateCommentContainer(id, commentContainerCode, position) {
    var container = $("#commentModal_"+ id);
    var commentContainer = container.find(".comments_container");
    switch (position) {
        case "pre":
            commentContainer.prepend(commentContainerCode);
            break;
        case "past":
            commentContainer.append(commentContainerCode);
            break;
    }
    return container;
}